export default __webpack_public_path__ + "static/media/digital-empire-small-10@2x.07ee5340.png";